import * as r from 'restructure';

// only used for encoding
/** @type {import('restructure').ArrayT} */
export default new r.Array(new r.Buffer());
